
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hi/contact",
      function () {
        return require("private-next-pages/hi/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hi/contact"])
      });
    }
  